module.exports = __webpack_public_path__ + "img/address_icon.51cabc47.svg";